import usePageMeta from "utils/usePageMeta";
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import OneOff_Section1 from "./sections/OneOff_Section1";
import OneOff_Section2 from "./sections/OneOff_Section2";
import OneOff_Section3 from "./sections/OneOff_Section3";
import OneOff_Section4 from "./sections/OneOff_Section4";

function OneOffCleaning() {
  usePageMeta({
    title: "One-Off Cleaning Services Ireland | Spechs",
    description:
      "Flexible one-off cleaning services for any occasion across Ireland. Professional and reliable.",
    canonical: "https://www.spechs.ie/cleaning/one-off/",
  });
  return (
    <SubPageLayout title="Once-Off Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <OneOff_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <OneOff_Section2 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <OneOff_Section3 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <OneOff_Section4 />
      </MKBox>
    </SubPageLayout>
  );
}

export default OneOffCleaning;
